<template>
  <div class="tab-selector">
    <div class="tab-selector__container">
      <div class="tab-selector__wrapper">
        <!-- Vertuo Tab -->
        <div
          class="tab-selector__tab vertuo tab-selector__tab--vertuo"
          :class="{ 'tab-selector__tab--active': selectedTab === 'vertuo' }"
          @click="selectTab('vertuo')"
        >
          <div
            class="tab-selector__tab-content tab-selector__image-container--vertuo"
          >
            <div class="tab-selector__image-container">
              <ImageWrapper
                src="/assets/images/tab1_img1.png"
                alt="Vertuo Machine"
                class="tab-selector__machine-image hide-below-lg"
              />
            </div>
            <div class="tab-selector__text-content">
              <h3 class="tab-selector__title">{{ $t("tab.vertuo.title") }}</h3>
              <p class="tab-selector__subtitle">
                {{ $t("tab.vertuo.subtitle") }}
              </p>
            </div>
            <ImageWrapper
              src="/assets/images/tab1_cap.png"
              alt="Original Capsule"
              class="tab-selector__capsule-image hide-below-lg"
            />
          </div>
        </div>

        <!-- Original Tab -->
        <div
          class="tab-selector__tab original tab-selector__tab--original"
          :class="{ 'tab-selector__tab--active': selectedTab === 'original' }"
          @click="selectTab('original')"
        >
          <div class="tab-selector__tab-content">
            <div
              class="tab-selector__image-container tab-selector__image-container--original"
            >
              <ImageWrapper
                src="/assets/images/napoli-capsule.png"
                alt="Original Capsule"
                class="tab-selector__capsule-image hide-below-lg"
              />
            </div>
            <div class="tab-selector__text-content">
              <h3 class="tab-selector__title">
                {{ $t("tab.original.title") }}
              </h3>
              <p class="tab-selector__subtitle">
                {{ $t("tab.original.subtitle") }}
              </p>
            </div>

            <ImageWrapper
              src="/assets/images/2025/tab2_machine.png"
              alt="Original Machine"
              class="tab-selector__machine-image hide-below-lg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImageWrapper } from "~/components/";

export default {
  name: "TabSelector",

  components: {
    ImageWrapper,
  },

  props: {
    selectedTab: {
      type: String,
      default: "original",
    },
  },

  methods: {
    /**
     * Handle tab selection and emit change event
     * @param {string} tab - The tab to select ('vertuo' or 'original')
     */
    selectTab(tab) {
      if (tab !== this.selectedTab) {
        this.$emit("input", tab);
        console.log("Tab changed to:", tab);
        this.$emit("tab-changed", tab);
      }
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content .app {
  .tab-selector {
    width: 100%;
    display: flex;
    justify-content: center;

    &__container {
      position: relative;
      width: rem(977);
      height: rem(87);
      max-width: 100%;
      padding-top: 30px;

      @include media-breakpoint-down(md) {
        width: 100%;
        height: auto;
      }
    }

    &__wrapper {
      position: absolute;
      top: rem(7);
      left: 50%;
      transform: translateX(-50%);
      // width: rem(968);
      height: rem(80);
      box-shadow: 0px 0px rem(9.7) 0px rgba(0, 0, 0, 0.15);
      display: flex;
      border-radius: rem(20);
      // overflow: hidden;
      max-width: calc(100vw - rem(40));
      width: 100%;
      // overflow: hidden;

      @include media-breakpoint-down(md) {
        width: 100%;
        max-width: unset;
        height: auto;
        position: relative;
        top: unset;
        left: unset;
        transform: none;
        box-shadow: 0px 0px rem(5) 0px rgba(0, 0, 0, 0.1);
      }
    }

    &__tab {
      flex: 1;
      position: relative;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: rem(80);

      @include media-breakpoint-down(md) {
        min-height: unset;
      }

      &--vertuo {
        margin-right: rem(-30);
        border-top-left-radius: rem(20);
        // border-bottom-left-radius: rem(20);

        @include media-breakpoint-down(md) {
          // border-radius: rem(20) rem(20) 0 0;
          margin-right: unset;
        }
      }

      &--original {
        z-index: 1;
        border-top-right-radius: rem(20);
        // border-bottom-right-radius: rem(20);

        @include media-breakpoint-down(md) {
          // border-radius: 0 0 rem(20) rem(20);
        }
      }

      // Active tab styling (like ORIGINAL)
      &--active {
        z-index: 2;
        background-color: color(crossSelling);
        box-shadow: -3px 0px rem(2.8) 0px rgba(0, 0, 0, 0.2);
        position: relative;
        z-index: 1;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: color(white);
        }

        .tab-selector__title {
          color: #935b41;
        }
        .tab-selector__subtitle {
          color: #935b41;
        }
      }

      // Inactive tab styling (like VERTUO)
      &:not(.tab-selector__tab--active) {
        background-color: color(white);

        .tab-selector__title {
          color: color(lightGray2);
        }
        .tab-selector__subtitle {
          color: color(lightGray2);
        }
      }
    }

    &__tab-content {
      display: flex;
      align-items: center;
      gap: rem(20);
      padding: rem(16);
      width: 100%;
      justify-content: center;

      @include media-breakpoint-down(md) {
        gap: rem(15);
        padding: rem(12);
      }
    }

    &__image-container {
      position: relative;
      flex-shrink: 0;

      &--vertuo {
        .tab-selector__capsule-image {
          width: rem(71);
          height: auto;
          margin-top: -2.3125rem;
        }
      }

      &--original {
        .tab-selector__capsule-image {
          transform: rotate(30.264deg);
          width: rem(95);
          height: rem(95);
        }
      }
    }

    &__machine-image {
      margin-top: rem(-26);
      width: auto;
      height: rem(81);

      @include media-breakpoint-down(md) {
        width: auto;
        height: rem(38);
      }
    }

    &__capsule-image {
      width: rem(95);
      height: rem(95);
      object-fit: cover;

      @include media-breakpoint-down(md) {
        width: rem(70);
        height: rem(70);
      }
    }

    &__text-content {
      display: flex;
      flex-direction: column;
      gap: rem(8);
      text-align: center;
      align-items: center;

      @include media-breakpoint-down(md) {
        gap: rem(4);
      }
    }

    &__title {
      font-weight: 700;
      font-size: rem(24);
      line-height: 1.2;
      letter-spacing: rem(2.4);
      text-transform: uppercase;
      margin: 0;
      transition: color 0.3s ease;

      @include media-breakpoint-down(md) {
        font-size: rem(20);
        letter-spacing: rem(2);
      }

      .tab-selector__tab--vertuo & {
        font-weight: 400;
      }

      .tab-selector__tab--original & {
        font-weight: 700;
      }
    }

    &__subtitle {
      font-weight: 600;
      font-size: rem(16);
      line-height: 1.2;
      letter-spacing: rem(0.8);
      margin: 0;
      white-space: nowrap;
      transition: color 0.3s ease;

      @include media-breakpoint-down(md) {
        font-size: rem(12);
        letter-spacing: rem(0.6);
        white-space: normal;
        text-align: center;
      }
    }
  }
}
</style>
